import React, {useState, useEffect,useContext} from 'react';
import { RootStoreContext } from '../../stores/RootStore';
import { StudentAttendanceMaxList, StudentAbsenceMaxParam } from '../../models/Attendance';
import { ISelect } from '../../models/General';
import Select from "react-select";
import 'react-datepicker/dist/react-datepicker.css';
import MonitoringPage from '../../utils/MonitoringPage';
import ExportButton from '../../utils/ExportButton';

const StudentAbsenceMaxListPage = () => {
    
    const rootStore = useContext(RootStoreContext);
    const { getStudentAbsenceMaxList,getAbsenceType } = rootStore.attendanceStore;
    const { getInstitution, getCareer, getSemester,getProgramByInstitution} = rootStore.commonStore; 
    const emplidVal =  window.localStorage.getItem('emplid'); 

    const [list, setList] = useState<StudentAttendanceMaxList[]>([]) 
    console.log(list)

    const [institution, setInstitution] = useState<ISelect[]>();
    const [institutionVal, setInstitutionVal] = useState<string>('');
    const [career, setCareer] = useState<ISelect[]>();
    const [careerVal, setCareerVal] = useState<string>('');
    const [semester, setSemester] = useState<ISelect[]>();
    const [semesterVal, setSemesterVal] = useState<string>('');
    const [program, setProgram] = useState<ISelect[]>();
    const [programVal, setProgramVal] = useState<string>('');

    const [type, setType] = useState<ISelect[]>();
    const [typeVal, setTypeVal] = useState<string>('');

    const [status, setStatus] =  useState("success") 
    const [message, setMessage] = useState("") 
    const [statusAlert, setStatusAlert] = useState(0) 
    const [btnExport, setBtnExport] = useState(true) 

    const [isLoading, setIsLoading] = useState(false)

    function handleInstitutionSelect(event: any) {
        setInstitutionVal(event.value);

        const careerData = getCareer(String(emplidVal), event.value);
        careerData.then(function(result) {
            setCareer(result);
        })

    };

    function handleCareerSelect(event: any) {
      
        setCareerVal(event.value);

        const programByInstitutionData = getProgramByInstitution(String(emplidVal), institutionVal, event.value);
        programByInstitutionData.then(function(result) {
            setProgram(result);
        })

        const semesterData = getSemester(institutionVal, event.value);
        semesterData.then(function(result) {
            setSemester(result);
        })

    };

    function handleSemesterSelect (event: any) {
        setSemesterVal(event.value)

    };

    function handleProgramSelect(event:any){
        setProgramVal(event.value)
    }

    const handleAbsenceTypeSelect = (event:any) => {
        setTypeVal(event.value)

    }

    const param: StudentAbsenceMaxParam = {
        INSTITUTION: String(institutionVal),
        ACAD_CAREER: String(careerVal),
        STRM: String(semesterVal),
        ACAD_PROG: String(programVal),
        TYPE: String(typeVal)
    };

    function loadData()
    {
        getStudentAbsenceMaxList(param).then(function(response) {
            setList(response)
            setIsLoading(false)
        })  
        .catch(() => {
            setStatusAlert(1)
            setMessage("Unable to fetch data")
            setStatus("danger")
            setIsLoading(false);
        });
    }

    const columns = [
        {title: "ID", field: "EMPLID",defaultSort:"asc",},
        {title: "Name", field: "NAME_DISPLAY",},
        {title: "Course Name", field: "MATAKULIAH"},
        {title: "Class", field: "CLASS_SECTION"},
        {title: "Number of Absences", field: "JUMLAH_ABSEN_DESC"},        
    ]

    useEffect(() => {

        if(institutionVal !== '' && semesterVal !== '' && careerVal !== '' && programVal !== '' && typeVal !== '' ){
            setIsLoading(true);
            setBtnExport(false)
        }

        const institutionData = getInstitution(String(emplidVal));
        institutionData.then(function(result) {
            setInstitution(result)
        })

        const absenceTypeData = getAbsenceType();
        absenceTypeData.then(function(result:any) {
            setType(result)
        })

        

        loadData()

    },[institutionVal, semesterVal,careerVal,programVal,typeVal])

    return (
        <React.Fragment>
           
           <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Student Absence</h1>
                        </div>
                    </div>
                </div>
            </div>
            

            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                                <label><span className='required-symbol'>*</span>Institution</label>
                                                <Select
                                                    name="institution"
                                                    placeholder="Choose Institution"
                                                    options={institution}
                                                    onChange={handleInstitutionSelect}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                                <label><span className='required-symbol'>*</span>Career</label>
                                                <Select
                                                    name="career"
                                                    placeholder="Choose Career"
                                                    options={career}
                                                    onChange={handleCareerSelect}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                                <label><span className='required-symbol'>*</span>Semester</label>
                                                <Select
                                                    name="semester"
                                                    placeholder="Choose Semester"
                                                    options={semester}
                                                    onChange={handleSemesterSelect}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                                <label><span className='required-symbol'>*</span>Program</label>
                                                <Select
                                                    name="program"
                                                    placeholder="Choose Program"
                                                    options={program}
                                                    onChange={handleProgramSelect}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                                <label><span className='required-symbol'>*</span>Absence Type</label>
                                                <Select
                                                    name="type"
                                                    placeholder="Choose Absence Type"
                                                    options={type}
                                                    onChange={handleAbsenceTypeSelect}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-1">
                                            <ExportButton
                                                showBtnExport={btnExport}
                                                setIsLoading={setIsLoading}
                                                apiURL={`${process.env.REACT_APP_API_URL}/academic/attendance/export-student-max/${institutionVal}/${careerVal}/${semesterVal}/${programVal}/${typeVal}`}
                                                filename={"Student_Absence_Recap.xls"}
                                            ></ExportButton>
                                           
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <MonitoringPage 
                        list={list} 
                        columns={columns} 
                        status={status} 
                        message={message} 
                        tableName={"Student List"}
                        tableMessage={""}
                        isLoading={isLoading}
                        statusAlert={statusAlert}
                        setStatusAlert={setStatusAlert}
                    ></MonitoringPage>

                </div>
            </section>
            
        </React.Fragment>
    );
}

export default StudentAbsenceMaxListPage;